import './MainExpertMode.styles.scss';

import { observer } from 'mobx-react';
import { FC, useMemo } from 'react';

import { useBackgroundTracker } from '../../../hooks/useBackgroundTracker';
import { useDateTimeSync } from '../../../hooks/useDateTimeSync';
import { useViewingTablesPopulator } from '../../../hooks/useViewingTablesPopulator';
import { useWebsocketSubscription } from '../../../hooks/useWebsocketSubscription';
import { Permission } from '../../../model/enumeration/Permission.enum';
import authStore from '../../../store/AuthStore';
import permissionStore from '../../../store/PermissionStore';
import { WEventsDispatcher } from '../../../websocket/handlers/WEventsDispatcher';
import ActiveTablesExpertMode from '../ActiveTablesExpertMode/ActiveTablesExpertMode';
import AvailableClubsTabsExpertMode from '../AvailableClubsTabsExpertMode/AvailableClubsTabsExpertMode';
import TableExpertMode from '../TableExpertMode/TableExpertMode';
import TableSectionsExpertMode from '../TableSectionsExpertMode/TableSectionsExpertMode';

const MainExpertMode: FC = () => {
  useBackgroundTracker();
  useWebsocketSubscription(
    '/user/tables/sync',
    WEventsDispatcher.processEventMessage,
  );

  useDateTimeSync();

  useViewingTablesPopulator();

  const hasChangeBotsClubsPermission = useMemo(
    () => permissionStore.hasPermission(Permission.CHANGE_BOTS_CLUBS),
    [authStore.authenticatedUser],
  );

  const hasManageBotsSeatingPermission = useMemo(
    () => permissionStore.hasPermission(Permission.MANAGE_BOTS_SEATING),
    [authStore.authenticatedUser],
  );

  useWebsocketSubscription(
    '/user/tables/waitlist-sync',
    WEventsDispatcher.processEventMessage,
    undefined,
    hasManageBotsSeatingPermission,
  );

  return (
    <div className="MainExpertMode-Component">
      {hasChangeBotsClubsPermission && <AvailableClubsTabsExpertMode />}
      <div className="main-content">
        <ActiveTablesExpertMode />
        <TableSectionsExpertMode />
        <TableExpertMode />
      </div>
    </div>
  );
};

export default observer(MainExpertMode);
